import { useState } from 'react';
import {
    Button,
    GlanceLoader,
    Tooltip
  } from '../ui-components';
  import React from 'react';
  import 'react-phone-number-input/style.css';
  import CountryPhoneInput from 'glance-design-core-components/CountryPhoneInput.jsx';
//TODO languages for phone number input.
function CameraShareState({onSend, onCancel=()=>{}, showCancel = true, minPhoneLength = 10, onVisitorOn = ()=>{}, onVisitorOff = ()=>{}, gicon, countries=["US","CA","IE","GB","JP"], languageManager}) {

    const enterPhoneText = "";
    const [phone, setPhone] = useState(enterPhoneText);
    const [sendDisabled, setSendDisabled] = useState(true);


    function isTooShort(str) {
      return str === undefined || str === null || str.trim().length < minPhoneLength;
    }

    function sendHandler(event) {
        event.preventDefault();
        if (!sendDisabled) {
            (typeof(onSend) === typeof(Function)) ? onSend(phone) : console.log("Send button clicked.");
        }
    }
    
    function cancelHandler(event) {
        event.preventDefault();
        setPhone("");//Clear phone input field.
        (typeof(onCancel) === typeof(Function)) ? onCancel() : console.log("Cancel button clicked.");
    }

    function keyChangeHandler(phoneNumber) {
        setPhone(phoneNumber);
        let invalidPhone = isTooShort(phoneNumber);
        setSendDisabled(invalidPhone);
    }

  /*let comboTextField = <ComboTextField
  size="large"
  id="TextInput"
  placeholder="Mobile #"
  shape="rounded-full"
  onChange={(e) => keyChangeHandler(e.target.value)}
  // named slots syntax slot[slotName in camelCase]
  slotIconLeft={<Icon name="phone" size="5.5" />}
  slotAction={
    <Tooltip text="Send SMS" offset={6} size="small">
      <Button
        size="small"
        variant="tertiary"
        disabled={sendDisabled}
        shape="rounded-full"
        onClick={sendHandler}
      >
        Send
      </Button>
    </Tooltip>*/
    let comboTextField = <div className="w-80">
                <CountryPhoneInput
                  placeholder={languageManager.getPhrase("integration-mobile-number","Mobile #")}
                  value={phone}
                  countries={countries}
                  defaultCountry="US"
                  onChange={keyChangeHandler}
                  shape="rounded-full"
                >
                   <span className="no-tooltip-arrow">
                    <Tooltip text={languageManager.getPhrase("integration-send-sms","Send SMS")} position="bottom" flip={true} shift={4} offset={2} size="small">
                      <Button
                        size="small"
                        variant="tertiary"
                        disabled={sendDisabled}
                        shape="rounded-full"
                        onClick={sendHandler}
                      >
                        {languageManager.getPhrase("integration-send","Send")}
                      </Button>
                    </Tooltip>
                  </span>
                </CountryPhoneInput>
              </div>

return (
    <>
      <div className="SizeWrapper">
      <div className="rowAlign">
        { gicon && <GlanceLoader size="12" spinning={false}></GlanceLoader> }
        <div className="w-80 mb-25">
        <label htmlFor="TextInput" className="offsetAfterLoader inline-flSex items-center gap-1 relative antialiased rtl:text-right typography-body-medium-body20 text-neutral-on-surface-text-default pb-1.5">{languageManager.getPhrase("integration-camera-share","Camera Share")}</label>
          <div className='borderContainer'>
          {comboTextField}
          {showCancel && <span className='buttonSep'>&nbsp;</span>}
          {showCancel && (<Button
            size="medium"
            variant="secondary"
            shape="rounded-full"
            className="cancel"
            animation={false}
            outline={true}
            onClick={cancelHandler}
          >
            {languageManager.getPhrase("integration-cancel","Cancel")}
          </Button>)}
        </div>
        </div>
        </div>
      </div>
    </>
  );
}

export default CameraShareState;